// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--HcBny","title":"a10a3f92e9--title--xh2nb","text":"a10a3f92e9--text--rKHHL"};